var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTypeleft = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17 3.106 7.78 11.56 17 20.014l-1.014 1.105-10.425-9.56L15.986 2 17 3.106Z"
})));
export { SvgTypeleft as ReactComponent };
export default __webpack_public_path__ + "4d05637b32eceefd608ed595f5b54959.svg";